import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth-service/auth.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { TranslocoService } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
  standalone: false,
})
export class ForgotPasswordComponent {
  profilForm = new FormGroup({
    email: new FormControl<string>('', [Validators.required, Validators.email]),
  });

  authService = inject(AuthService);
  notificationService = inject(NotificationService);
  transloco = inject(TranslocoService);
  loading = false;

  async onForgotPassword(): Promise<void> {
    const email = this.profilForm.get('email')?.value;

    if (email) {
      this.loading = true;
      this.authService.forgotPassword(email).subscribe({
        next: async () => {
          const message = await firstValueFrom(
            this.transloco.selectTranslate('forgotPasswordPage.successMessage'),
          );
          this.notificationService.success(message);
          this.loading = false;
        },
        error: async (error) => {
          console.error('Sent request email failed:', error);
          const message = await firstValueFrom(
            this.transloco.selectTranslate('forgotPasswordPage.errorMessage'),
          );
          this.notificationService.error(message);
          this.loading = false;
        },
      });
    } else {
      const message = await firstValueFrom(
        this.transloco.selectTranslate(
          'forgotPasswordPage.missingEmailWarning',
        ),
      );
      this.notificationService.warn(message);
    }
  }

  get isEmailInvalid(): boolean {
    const emailControl = this.profilForm.get('email');
    return (
      (emailControl?.invalid &&
        (emailControl?.touched || emailControl?.dirty)) ??
      false
    );
  }
}
